export function toToastItem(toast, status) {
    return {
        id: toast.props.toastId,
        type: toast.props.type,
        status: status,
    };
}
